import React, { Component } from 'react' 
import About from './components/About'
import Footer from './components/Footer'
import Header from './components/Header'
import Features from './components/Features';
import QuoteWithoutButton from './components/QuoteWithoutButton';
import Video from './components/Video';
import Carousel from './components/Carousel';

export class Home extends Component {  
    render() {  
        return (
            <div>
                <title>Home | AGT Construction Services Ltd.</title>
                <Header></Header>
                <Video></Video>
                <About></About>
                <Carousel></Carousel>
                <Features></Features>
                <QuoteWithoutButton></QuoteWithoutButton>
                <Footer></Footer>
            </div>  
        )  
    }  
}  
  
export default Home  